<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Presença do participante na reunião."
    closeAriaLabel="Fechar"
    header="Alterar Presença"
    [visible]="visivel()"
    (visibleChange)="visivel.set($event)"
    [style]="{ width: '450px', border: 'none' }"
    styleClass="dialogo-presenca-custom"
    appendTo="body"
    (onHide)="fechar()"
>
    @if (participante(); as participanteAtual) {
        <div class="flex flex-col gap-4 py-2 px-1">
            <div class="p-3 bg-surface-50 dark:bg-surface-800/50 rounded-lg">
                <span class="text-xs text-muted-color uppercase font-bold tracking-wider">{{ tipo() === 'M' ? 'Membro' : 'Convidado' }}</span>
                <div class="text-base font-semibold text-color mt-0.5">{{ participanteAtual.nome }}</div>
                <div class="text-xs text-muted-color mt-0.5">UF: {{ participanteAtual.uf }} | Código: {{ participanteAtual.idSolicitante }}</div>
            </div>

            <div class="flex flex-col gap-2">
                <span class="text-sm font-bold text-color">Selecione a situação de presença:</span>
                <div class="grid grid-cols-2 gap-2">
                    @for (opcao of opcoes(); track opcao.value) {
                        <button
                            type="button"
                            (click)="escolher(opcao.value)"
                            class="flex items-center gap-2.5 p-2.5 rounded-lg text-left transition-all duration-200 cursor-pointer border-0"
                            [ngClass]="{
                                'bg-primary-50 dark:bg-primary-950/40 text-primary-700 dark:text-primary-400 font-semibold shadow-sm': selecionado() === opcao.value,
                                'bg-surface-50 dark:bg-surface-800/50 hover:bg-surface-100 dark:hover:bg-surface-800 text-color': selecionado() !== opcao.value
                            }"
                        >
                            <span class="flex items-center justify-center w-7 h-7 rounded-full bg-surface-100 dark:bg-surface-800">
                                <i [class]="icone(situacaoDaOpcao(opcao.value)) + ' text-base'" [ngClass]="classe(situacaoDaOpcao(opcao.value))"></i>
                            </span>
                            <span class="text-xs font-semibold leading-tight">{{ opcao.label }}</span>
                        </button>
                    }
                </div>
            </div>
        </div>
    }
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 pt-2">
            <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="fechar()"></button>
            <button type="button" pButton label="Confirmar" severity="primary" [appCan]="roleGerenciarConvidados" (click)="aoConfirmar()"></button>
        </div>
    </ng-template>
</p-dialog>
